import DataRoomDocEmpty from './DataRoomDocEmpty.component';

export default DataRoomDocEmpty;